import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material';

export const CoaxialIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Top tilted tube */}
    <rect x="5" y="4.5" width="14" height="3" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(-8 12 6)" />
    <circle cx="5" cy="6" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="19" cy="6" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
    {/* Middle tilted tube */}
    <rect x="5" y="10" width="14" height="3" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(-8 12 11.5)" />
    <circle cx="5" cy="11.5" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="19" cy="11.5" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
    {/* Bottom tilted tube */}
    <rect x="5" y="15.5" width="14" height="3" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(-8 12 17)" />
    <circle cx="5" cy="17" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="19" cy="17" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
  </SvgIcon>
); 